export default class Basket {
    constructor() {
        this.init = this.init.bind(this);

        this.hasMattress = false;

        this.init();
    }

    // Will wait for the spinner to finish loading.
    waitForElement(query, timeout = 10000) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const tryQuery = () => {
                const elem = document.querySelector(query);
                if (elem) resolve(elem); // Found the element
                else if (Date.now() - startTime > timeout) resolve(null); // Give up eventually
                else setTimeout(tryQuery, 10); // check again every 10ms
            };
            tryQuery(); // Initial check
        });
    }

    checkForMattress() {
        const basketEntries = document.querySelectorAll('.woocommerce-cart-form__cart-item');
        basketEntries.forEach(entry => {
            if (!entry.querySelector('.product-name')) return;
            const productName = entry.querySelector('.product-name').textContent.toLowerCase();
            if (productName.includes('mattress')) {
                this.hasMattress = true;
            }
        });
    }

    showRightCTA() {
        if (!this.hasMattress) return;

        const mattressCTA = document.querySelector('[data-block="complete-the-look-mattress"]');
        if (!mattressCTA) return;

        mattressCTA.classList.remove('hidden');

        const nonMattressCTA = document.querySelector('[data-block="complete-the-look"]');
        if (!nonMattressCTA) return;
        nonMattressCTA.classList.add('hidden');
    }

    async init() {
        try {
            const item = await this.waitForElement('.woocommerce-cart-form__cart-item');
            if (!item) return;

            this.checkForMattress();
            this.showRightCTA();
        } catch (error) {
            console.warn('Basket page Error:', error);
        }
    }
}

if (window.location.pathname.includes('/basket/')) new Basket();
